<!-- ! marque with url image -->

<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="enregistrementTerminer;else attente"></div>
<mat-card class="example-card">
  <mat-card-content>
    <div>
      <span style="cursor: pointer" (click)="importer()">
        <img id="img_30_30" src="assets/icon.png" height="30px" style="margin-right: 10px">
        <input id="input_30_30" type="file" value="importer" style="display:none;" (change)="onChangeImagefile($event)">
      </span>
      <mat-form-field style="margin-right: 10px">
        <input matInput disabled="true" name="Marque_Code" #groupe_code="ngModel" [(ngModel)]="marque.Marque_Code"
          placeholder="Code">
      </mat-form-field>
      <mat-form-field style="margin-right: 10px">
        <input matInput name="Marque_Label" #groupe_code="ngModel" [(ngModel)]="marque.Marque_Label"
          placeholder="Texte">
      </mat-form-field>
      <span class="button-row" style="margin-right: 10px">
        <button type="button" [disabled]="disabledBtnAjouter" (click)="addFiles()" class="bet_time" mat-raised-button
          color="primary">Ajouter</button>
      </span>
      <span class="button-row" style="margin-right: 10px">
        <button type="button" [disabled]="disabledBtnAjouter" (click)="modifier()" class="bet_time" mat-raised-button
          color="primary">Modifier</button>
      </span>
      <span class="button-row">
        <button type="button" [disabled]="disabledBtnsupprimer" (click)="supprimer()" class="colorReed"
          mat-raised-button>Supprimer</button>
      </span>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between none">
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>

    </div>
    <div class="example-table-container">
      <table id="tableCategories" mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="Marque_Icon">
          <th mat-header-cell *matHeaderCellDef> Icon </th>
          <td mat-cell *matCellDef="let element">
            <img [src]="generalService.base_url +'images/' +element.Marque_Icon" height="30px">
          </td>
        </ng-container>
        <ng-container matColumnDef="Marque_Label">
          <th mat-header-cell *matHeaderCellDef> Text </th>
          <td mat-cell *matCellDef="let element"> {{element.Marque_Label}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRowGroupe($event,row)"></tr>
      </table>
    </div>

  </mat-card-content>
</mat-card>
<!-- 
<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="enregistrementTerminer;else attente"></div>
<mat-card class="example-card">
  <mat-card-content>
    <div>
      <span style="cursor: pointer" (click)="importer()">
        <img id="img_30_30" src="assets/icon.png" height="30px" style="margin-right: 10px">
        <input id="input_30_30" type="file" value="importer" style="display:none;" (change)="onChangeImagefile($event)">
      </span>
      <mat-form-field style="margin-right: 10px">
        <input matInput disabled="true" name="Marque_Code" #groupe_code="ngModel" [(ngModel)]="marque.Marque_Code"
          placeholder="Code">
      </mat-form-field>
      <mat-form-field style="margin-right: 10px">
        <input matInput name="Marque_Label" #groupe_code="ngModel" [(ngModel)]="marque.Marque_Label"
          placeholder="Texte">
      </mat-form-field>
      <span class="button-row" style="margin-right: 10px">
        <button type="button" [disabled]="disabledBtnAjouter" (click)="ajouter()" class="bet_time" mat-raised-button
          color="primary">Ajouter</button>
      </span>
      <span class="button-row" style="margin-right: 10px">
        <button type="button" [disabled]="disabledBtnAjouter" (click)="modifier()" class="bet_time" mat-raised-button
          color="primary">Modifier</button>
      </span>
      <span class="button-row">
        <button type="button" [disabled]="disabledBtnsupprimer" (click)="supprimer()" class="colorReed"
          mat-raised-button>Supprimer</button>
      </span>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between none">
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>

    </div>
    <div class="example-table-container">
      <table id="tableCategories" mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="Marque_Icon">
          <th mat-header-cell *matHeaderCellDef> Icon </th>
          <td mat-cell *matCellDef="let element">
            <img [src]="element.Marque_Icon" height="30px">
          </td>
        </ng-container>
        <ng-container matColumnDef="Marque_Label">
          <th mat-header-cell *matHeaderCellDef> Text </th>
          <td mat-cell *matCellDef="let element"> {{element.Marque_Label}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRowGroupe($event,row)"></tr>
      </table>
    </div>

  </mat-card-content>
</mat-card> -->
